import Star from 'themes/playful/assets/star.svg';

import { useWebsite } from 'hooks/website/useWebsite';

import s from './HeroImage.module.css';

export const HeroImage = () => {
  const { home } = useWebsite();

  const heroImage = home.hero.image;
  const backgroundImage = `linear-gradient(0deg, rgb(0  0  0 / 25%), rgb(0  0  0 / 25%)), url(${heroImage})`;

  const heroStyles = heroImage
    ? {
        backgroundImage,
      }
    : {};

  return (
    <div className={s.hero} style={heroStyles}>
      <Star />
    </div>
  );
};
